<h2 class="dialog-title">
  Attachments
  <span class="close-icon" (click)="close()">✕</span>
</h2>

<div class="dialog-body">
  <!-- Select All -->
  <div class="select-all">
    <mat-checkbox [(ngModel)]="selectAllChecked" (change)="toggleSelectAll($event)">Select All</mat-checkbox>

    <button mat-icon-button class="download-all-btn" *ngIf="hasAnySelected" (click)="downloadSelected()" title="Download Selected">
      <mat-icon>download</mat-icon>
    </button>
  </div>

  <!-- Files -->
  <div class="file-grid">
    <div class="file-card" *ngFor="let file of attachments">
      <div class="file-left">
        <mat-checkbox [(ngModel)]="file.isChecked" (change)="onCheckboxChange()"></mat-checkbox>

        <span class="file-name" title="{{ file.fileName }}">
          {{ file.fileName }}
        </span>
      </div>

      <!-- <a
        class="download-link"
        (click)="downloadSingle(file)">
        Download
      </a> -->
      <button mat-icon-button class="download-all-btn" (click)="downloadAttachment(file.fileName)" title="Download Selected">
        <mat-icon>download</mat-icon>
      </button>
    </div>
  </div>
</div>
